import { API } from "../api/api";
import type { BuilderGroup, CustomizationCatalog } from "../types";

type ApiPrice = string | number;
type ApiExtra = { id: number; name: string; price: ApiPrice };

interface ApiCatalog {
  extras: ApiExtra[];
  products: CustomizationCatalog["products"];
  builder?: {
    product: Omit<NonNullable<CustomizationCatalog["builder"]>["product"], "price"> & { price: ApiPrice };
    groups: Array<Omit<BuilderGroup, "ingredients"> & { ingredients: ApiExtra[] }>;
  } | null;
}

const toExtra = (extra: ApiExtra) => ({ ...extra, price: Number(extra.price) });

export const fetchCustomizationCatalog = async (): Promise<CustomizationCatalog> => {
  const { data } = await API.get<ApiCatalog>("/products/customizations");
  return {
    extras: data.extras.map(toExtra),
    products: data.products ?? {},
    builder: data.builder
      ? {
          product: { ...data.builder.product, price: Number(data.builder.product.price) },
          groups: data.builder.groups.map((g) => ({ ...g, ingredients: g.ingredients.map(toExtra) })),
        }
      : null,
  };
};
